/**
 * Machine-readable error codes for the encounters API. The shared problem
 * details filter keeps only `detail`, so the server puts the code string in
 * the exception message and clients match on it.
 */ /** HTTP 409: the SOAP note's `version` no longer matches the stored row. */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ENCOUNTER_LABS_CHANGED () {
        return ENCOUNTER_LABS_CHANGED;
    },
    get ENCOUNTER_LAB_LIMIT () {
        return ENCOUNTER_LAB_LIMIT;
    },
    get ENCOUNTER_LOCKED () {
        return ENCOUNTER_LOCKED;
    },
    get ENCOUNTER_NOT_AUTHOR () {
        return ENCOUNTER_NOT_AUTHOR;
    },
    get ICD10_CODE_UNKNOWN () {
        return ICD10_CODE_UNKNOWN;
    },
    get LAB_RESULT_NOT_ATTACHABLE () {
        return LAB_RESULT_NOT_ATTACHABLE;
    },
    get SOAP_INCOMPLETE () {
        return SOAP_INCOMPLETE;
    },
    get SOAP_VERSION_CONFLICT () {
        return SOAP_VERSION_CONFLICT;
    },
    get VITALS_VERSION_CONFLICT () {
        return VITALS_VERSION_CONFLICT;
    }
});
const SOAP_VERSION_CONFLICT = 'SOAP_VERSION_CONFLICT';
const VITALS_VERSION_CONFLICT = 'VITALS_VERSION_CONFLICT';
const ENCOUNTER_LOCKED = 'ENCOUNTER_LOCKED';
const SOAP_INCOMPLETE = 'SOAP_INCOMPLETE';
const ENCOUNTER_NOT_AUTHOR = 'ENCOUNTER_NOT_AUTHOR';
const ICD10_CODE_UNKNOWN = 'ICD10_CODE_UNKNOWN';
const ENCOUNTER_LABS_CHANGED = 'ENCOUNTER_LABS_CHANGED';
const LAB_RESULT_NOT_ATTACHABLE = 'LAB_RESULT_NOT_ATTACHABLE';
const ENCOUNTER_LAB_LIMIT = 'ENCOUNTER_LAB_LIMIT';
